import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "@/locales/it.json";
import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import fr from "@/locales/fr.json";
import es from "@/locales/es.json";
import pt from "@/locales/pt.json";
import ar from "@/locales/ar.json";
import zh from "@/locales/zh.json";
import hi from "@/locales/hi.json";

export const SUPPORTED_LOCALES = ["it", "en", "ru", "fr", "es", "pt", "ar", "zh", "hi"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "it";

/**
 * The translation files are flat dictionaries with dotted keys
 * (e.g. "header.menu.home"). We disable nested key separators so
 * i18next treats them as literal strings.
 */
i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it as Record<string, string> },
    en: { translation: en as Record<string, string> },
    ru: { translation: ru as Record<string, string> },
    fr: { translation: fr as Record<string, string> },
    es: { translation: es as Record<string, string> },
    pt: { translation: pt as Record<string, string> },
    ar: { translation: ar as Record<string, string> },
    zh: { translation: zh as Record<string, string> },
    hi: { translation: hi as Record<string, string> },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
});

export default i18n;

export function isLocale(value: string | undefined): value is Locale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}